import { Link } from "react-router-dom";
import e_logo from 'assets/E_Logo.svg';
import mask_logo_icon from 'assets/mask_with_opacity_icon.svg';
import styled from 'styled-components';

export default function NotFoundApp() {
  return (
    <Root>
      <Header>
        <Logo src={e_logo} alt="EroPlay Logo" />
      </Header>
      <Content>
        <ErrorContent>
          <MaskIcon src={mask_logo_icon} alt="Mask Icon" />
          <Title>Oops! Page Not Found</Title>
          <Description>
            The page you are looking for does not exist. Head back to our homepage to continue exploring our site.
          </Description>
          <HomeButton to="/">Go to Home page</HomeButton>
        </ErrorContent>
      </Content>
    </Root>
  );
}

const Root = styled.div`
  min-height: 100vh;
  width: 100%;
  background: #0D0D0D;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Header = styled.header`
  width: 100%;
  padding: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Logo = styled.img`
  width: 120px;
  height: 27px;
  flex-shrink: 0;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 120px;

  @media (max-width: 768px) {
    margin-top: 0;
    flex: 1;
    margin-top: 200px;
    justify-content: center;
    padding: 0;
  }

  @media (max-width: 375px) {
    margin-top: 100px;
  }
`;

const ErrorContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 320px;
  padding: 0 16px;
`;

const MaskIcon = styled.img`
  width: 86px;
  height: 86px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    width: 64px;
    height: 64px;
    margin-bottom: 16px;
  }
`;

const Title = styled.h1`
  color: #FFF;
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 12px;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 8px;
  }
`;

const Description = styled.p`
  margin-bottom: 24px;
  text-align: center;
  color: #FFF;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  opacity: 0.8;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 20px;
  }
`;

const HomeButton = styled(Link)`
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  border-radius: 64px;
  background: #FF7E55;
  box-shadow: 0px 12px 40px 0px rgba(255, 126, 85, 0.12);
  color: #FFF;
  border: none;
  text-align: center;
  font-family: "Nunito Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  text-decoration: none;

  @media (max-width: 768px) {
    padding: 10px 20px;
  }

  &:hover {
    background: #FF6B3C;
  }
`; 